import PropTypes from 'prop-types';
import useFooterQuery from 'queries/useFooterQuery';
import FooterCore from '@activebrands/core-web/components/Footer';
import { styled } from '@activebrands/core-web/libs/styletron';
import FooterBottom from 'components/Footer/FooterBottom';
import FooterMenu from 'components/Footer/FooterMenu';
import fm from 'format-message';
import transformHeading from '@activebrands/core-web/libs/storyblok/utils/transform-heading';
import transformParagraph from '@activebrands/core-web/libs/storyblok/utils/transform-paragraph';

const FooterWrapper = styled('div', {
    backgroundColor: 'var(--color-bg-footer-primary)',
});

const Footer = ({ alternateHrefs = [], previewDataOverride }) => {
    const content = previewDataOverride || useFooterQuery();

    const {
        items,
        featuredLinks,
        featuredLinksLabel,
        informationHeading,
        informationParagraphs,
        footerContent,
        copywriteText,
    } = content;

    return (
        <FooterCore aria-label={fm("Footer section")} footerContent={footerContent}>
            <FooterWrapper>
                <FooterMenu
                    featuredLinks={featuredLinks}
                    featuredLinksLabel={featuredLinksLabel}
                    informationHeading={transformHeading({ heading: informationHeading })}
                    informationParagraphs={informationParagraphs.map((paragraph) => transformParagraph({ paragraph }))}
                    items={items || []}
                />
                <FooterBottom alternateHrefs={alternateHrefs} copywriteText={copywriteText} />
            </FooterWrapper>
        </FooterCore>
    );
};

Footer.propTypes = {
    alternateHrefs: PropTypes.array,
    previewDataOverride: PropTypes.object,
};

export default Footer;
